/* eslint-disable */
/*
Notes: we should combine code from CreatePostSaga and EditPostScreen into PostSagas.js.
Right now we have three sets of code, each screen choosing which to use.
*/

import { select, all, call, put, fork, take } from 'redux-saga/effects'

import CouponActions from '../Redux/CouponRedux'
// import AuthActions from '../Redux/AuthRedux'
import {responseToChanges, exceptionToChanges} from '../Lib/utils'

/*
const responseToChanges = (title, response) => {
  console.tron.display({name: responseToChanges, preview: title, value: {response}})
  const apiResponse = typeof response.data != 'undefined' ? response.data : null
  const errorMessage = apiResponse && typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['detail'] : "Unknown"
  const result = {
    phase: 'error',
    error: {
      httpCode: response.status, // response.respInfo.status
      code:     apiResponse && typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['code'] : -1,
      title:    title,
      detail:   errorMessage,
    },
    logRef:   apiResponse && typeof apiResponse.logRef != 'undefined' ? apiResponse.logRef : null,
    modified: Date.now()
  }
  return result
}

const exceptionToChanges = (title, error) => {
  console.tron.display({name: 'exceptionToChanges', preview: title, value: {error}})
  const result = {
    phase: 'error',
    error: {
      httpCode:  null,
      code:      -1,
      title:     title,
      detail:    error.message,
      exception: error,
    },
    logRef:    null,
    modified: Date.now()
  }
  return result
}

const fakeId = () => {
    return Math.floor(Math.random() * 10000000).toString()
}

const fakeOffer = (offerId = null) => {
  if (!offerId)
    offerId = fakeId()
  return {
    OfferId: fakeId(),
    ImageUrl: null,
    VendorName: 'Little Spain',
    Description: 'Enjoy a free drink with your meal at Little Spain in Hudson Yards!',
    QRCode: fakeId(),
    Instructions: 'Present At Restaurant',
    Terms: 'Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here. Any terms or rules for the coupon would go here.',
    TimeStamp: Date.now(),
    GoodFrom: '190730',
    GoodUntil: '190915',
  }
}

const fakeCoupon = (couponId = null) => {
  if (!couponId)
    couponId = fakeId()
  return Object.assign({}, fakeOffer(), {
    UserId: fakeId(),
    CouponId: couponId,
    Redeemed: false,
    TimeStamp: Date.now(),
  })
}


const fakeUserCouponsResponse = () => {
  return {
    ok: true,
    data: {
      logRef: fakeId(),
      data: [
        // list of coupons
        fakeCoupon('1001'),
        fakeCoupon('1002'),
        fakeCoupon('1003'),
        fakeCoupon('1004'),
      ]
    }
  }
}

const fakeCouponResponse = (couponId = null) => {
  return {
    ok: true,
    data: {
      logRef: fakeId(),
      data: fakeCoupon(couponId),
    }
  }
}

const fakeOfferResponse = (OfferId, Code) => {
  return {
    ok: true,
    data: {
      logRef: fakeId(),
      data: fakeOffer(OfferId)
    }
  }
}
*/

function userCouponsListToChanges(list, apiResponse) {
  let byVendor = {}
  for (var entry of list) {
    const vendorName = entry['VendorName']
    // console.tron.display({name: 'CouponSagas', preview: `userCoupons`, value: {list, entry, vendorName, byVendor}})
    const entryImageUrl = entry.ImageUrl.trim()
    if (typeof byVendor[vendorName] == 'undefined')
      byVendor[vendorName] = {
        id: vendorName, // for rendering
        VendorName: vendorName,
        VendorId: null, // future - maybe avatar
        ImageUrl: entryImageUrl != '' ? entryImageUrl : null,
        list: []
      }
    byVendor[vendorName].list.push(Object.assign({}, entry))
    if (!byVendor[vendorName].ImageUrl && entryImageUrl)
      byVendor[vendorName].ImageUrl = entryImageUrl
  }
  const vendorNames = Object.keys(byVendor).sort()
  byVendor = Object.values(byVendor)
  byVendor.sort(function(a, b) {
    const aKey = a.VendorName
    const bKey = b.VendorName
    if (aKey < bKey) return -1
    if (aKey > bKey) return 1
    return 0
  })
  console.tron.display({name: 'CouponSagas', preview: `byVendor after sort`, value: {byVendor}})
  const changes = {
    phase: 'success',
    modified: Date.now(),
    list,
    byVendor,
    vendorNames,
    logRef: apiResponse.logRef
  }
  return changes
}

export const userCoupons = function* userCoupons(api, action) {
  try {
    const response = yield call(api.userCoupons)
    if (response.ok) {
      const apiResponse = response.data
      const list = apiResponse.data
      const changes = userCouponsListToChanges(list, apiResponse)
      yield put(CouponActions.couponSuccess('userCoupons', changes))
    }
    else {
      yield put(CouponActions.couponFailure('userCoupons', responseToChanges("Coupon List Exception", response)))
    }
  }
  catch (error) {
    yield put(CouponActions.couponFailure('userCoupons', exceptionToChanges("Coupon List Exception", error)))
  }
}

export const getOffer = function* getOffer(api, action) {
  try {
    const { OfferId = null, Code = null } = action
    console.log('in getOffer for OfferId = ' + OfferId)
    if (!OfferId) {
      console.log("avoiding calling the API with no OfferId (CouponSagas getOffer)")
      return
    }
    // const response = fakeOfferResponse(OfferId, Code)
    const response = yield call(api.getOffer, OfferId, Code)
    if (response.ok) {
      const apiResponse = response.data
      const changes = {
        phase: 'success',
        modified: Date.now(),
        record: apiResponse.data ? apiResponse.data[0] : null,
        logRef: apiResponse.logRef
      }
      yield put(CouponActions.couponSuccess('getOffer', changes))
    }
    else {
      yield put(CouponActions.couponFailure('getOffer', responseToChanges("Get Offer Exception", response)))
    }
  }
  catch (error) {
    yield put(CouponActions.couponFailure('getOffer', exceptionToChanges("Get Offer Exception", error)))
  }
}

export const redeemCoupon = function* redeemCoupon(api, action) {
  try {
    const { CouponId } = action
    console.tron.log(`CouponSagas redeemCoupon ${CouponId}`);
    const response = yield call(api.redeemCoupon, CouponId)
    if (response.ok) {
      const apiResponse = response.data
      const changes = {
        phase: 'success',
        modified: Date.now(),
        record: apiResponse.data[0],
        logRef: apiResponse.logRef
      }
      yield put(CouponActions.couponSuccess('redeemCoupon', changes))
      const state = yield select() // grab state
      const { coupon } = state
      console.tron.display({name: 'redeemCoupon', preview: `state.coupon`, value: {coupon}})
      if (coupon.userCoupons.phase == 'success') {
        let list = [...coupon.userCoupons.list]
        for (let i = 0; i < list.length; i++)
          if (list[i].CouponId == CouponId) {
            list[i] = Object.assign({}, list[i], {Redeemed: new Date().getTime()/1000})
            console.tron.display({name: 'redeemCoupon', preview: `found redeemed in list`, value: {i, list, CouponId}})
          }
        const changes = userCouponsListToChanges(list, apiResponse)
        console.tron.display({name: 'redeemCoupon', preview: `userCoupon changes`, value: {list, changes}})
        yield put(CouponActions.couponSuccess('userCoupons', changes)) // quick update on our user coupons for OnevendorCoupons screen
      }
      else {
        console.tron.log(`redeemCoupon, slow update for user coupons, does not work`)
        // userCoupons(api, null) // just get all the coupons again, slower
      }
    }
    else {
      yield put(CouponActions.couponFailure('redeemCoupon', responseToChanges("Redeem Coupon Exception", response)))
    }
  }
  catch (error) {
    yield put(CouponActions.couponFailure('redeemCoupon', exceptionToChanges("Redeem Coupon Exception", error)))
  }
}

export const vendorOffers = function* vendorOffers(api, action) {
  try {
    const { UserId = null } = action
    console.tron.log(`CouponSagas vendorOffers ${UserId}`);
    const response = yield call(api.vendorOffers, UserId)
    if (response.ok) {
      const apiResponse = response.data
      const changes = {
        phase: 'success',
        modified: Date.now(),
        list: apiResponse.data,
        logRef: apiResponse.logRef
      }
      yield put(CouponActions.couponSuccess('vendorOffers', changes))
    }
    else {
      yield put(CouponActions.couponFailure('vendorOffers', responseToChanges("Vendor Offers Exception", response)))
    }
  }
  catch (error) {
    yield put(CouponActions.couponFailure('vendorOffers', exceptionToChanges("Vendor Offers Exception", error)))
  }
}

export const getVendor = function* getOffer(api, action) {
  // why this and not UserActions.getUser? So that the ComponentDidUpdate functions know when fetching a user was result of a barcode scan
  try {
    const { UserId = null } = action
    console.tron.log(`in getVendor for UserId ${UserId}`)
    const response = yield call(api.readUser, UserId)
    if (response.ok) {
      const apiResponse = response.data
      const user = apiResponse.data ? apiResponse.data[0] : null
      if (user) {
        const storeResponse = yield call(api.readStore, UserId)
        if (storeResponse.ok) {
          let store = storeResponse.data.data ? Object.assign({}, storeResponse.data.data[0]) : {} // ok if store record is missing, it is possible
          if (typeof store.StoreName == 'undefined')
            store.StoreName = user.Username
          const changes = {
            phase: 'success',
            modified: Date.now(),
            record: Object.assign({}, store, user),
            logRef: apiResponse.logRef
          }
          console.tron.display({name: 'CouponSagas', preview: `getVendor`, value: {UserId, user, store, changes}})
          yield put(CouponActions.couponSuccess('getVendor', changes))
        }
        else
          yield put(CouponActions.couponFailure('getVendor', responseToChanges("Get Store Exception", storeResponse)))
      }
      else
        yield put(CouponActions.couponFailure('getVendor', exceptionToChanges("Get User Exception", {message: "Get User returned an empty record"})))
    }
    else
      yield put(CouponActions.couponFailure('getVendor', responseToChanges("Get User Exception", response)))
  }
  catch (error) {
    yield put(CouponActions.couponFailure('getVendor', exceptionToChanges("Get User Exception", error)))
  }
}

export const allOffers = function* allOffers(api, action) {
  try {
    console.tron.log(`CouponSagas allOffers`);
    const response = yield call(api.allOffers)
    if (response.ok) {
      const apiResponse = response.data
      const changes = {
        phase: 'success',
        modified: Date.now(),
        list: apiResponse.data,
        logRef: apiResponse.logRef
      }
      yield put(CouponActions.couponSuccess('allOffers', changes))
    }
    else {
      yield put(CouponActions.couponFailure('allOffers', responseToChanges("All Offers Exception", response)))
    }
  }
  catch (error) {
    yield put(CouponActions.couponFailure('allOffers', exceptionToChanges("All Offers Exception", error)))
  }
}
